import { ReactComponent as CheckedIcon } from "../../../../../assets/icon/checked.svg";
import { CheckedIconStyled } from './CheckedIcon.styled';

export const CheckedIconContainer = () => {
  return <CheckedIconStyled><CheckedIcon/></CheckedIconStyled>
}